import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _templateObject, _templateObject2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx jsx */
import { useCallback, useState } from 'react';
import { css, jsx } from '@emotion/core';
import Button from '@atlaskit/button/custom-theme-button';
import { fontSize } from '@atlaskit/theme/constants';
import SuccessContainer from './SuccessContainer';
export default (function (_ref) {
  var onAnswer = _ref.onAnswer;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var answeredWith = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(answer) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setPending(answer ? 'yes' : 'no');
            _context.next = 3;
            return onAnswer(answer);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [setPending, onAnswer]);
  var isDisabled = Boolean(pending);
  return jsx(SuccessContainer, null, jsx("h1", {
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          font-size: ", "px;\n          font-weight: 600;\n          margin: 0;\n          line-height: ", ";\n        "])), fontSize(), "var(--ds-font-lineHeight-300, 24px)")
  }, "Thanks for your feedback"), jsx("p", null, "Are you interested in participating in our research?"), jsx("p", null, "Sign up for the", ' ', jsx("a", {
    href: "https://www.atlassian.com/research-group"
  }, "Atlassian Research Group"), ' ', "and we may contact you in the future with research opportunities."), jsx("div", {
    css: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          margin-top: ", ";\n          display: flex;\n          justify-content: flex-end;\n\n          & > * + * {\n            margin-left: ", ";\n          }\n        "])), "var(--ds-space-400, 32px)", "var(--ds-space-100, 8px)")
  }, jsx(Button, {
    appearance: "subtle",
    onClick: function onClick() {
      return answeredWith(false);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'no'
  }, "No, thanks"), jsx(Button, {
    appearance: "primary",
    onClick: function onClick() {
      return answeredWith(true);
    },
    isDisabled: isDisabled,
    isLoading: pending === 'yes'
  }, "Yes, sign me up")));
});